import { useEffect } from 'react';
import { withAuthProvider } from '../auth';
import { initTrackingContext, initTracking } from './tracking';

const SegmentWrapper = ({isLoggedIn, me}) => {

  useEffect(() => {

    if (typeof window === 'undefined') return;

    const userData = isLoggedIn && me ? {
      id: me.externalId || me.id,
      ...me
    } : null;

    initTrackingContext({
      user: userData,
      isLoggedIn
    });

    if (isLoggedIn && userData && window.analytics.identify) {
      window.analytics.identify(userData.id, {
        ...userData
      });
    } else if (window.analytics) {
      window.analytics.reset();
    }

    initTracking();

  }, [isLoggedIn, me]);

  return null;
};

export default withAuthProvider(SegmentWrapper);